import styled from 'styled-components'

export const PanelImageStyled = styled.img`
  margin: 1em auto;
  max-width: 100%;
`
export const PanelBodyStyled = styled.div`
  text-align: center;
  max-width: 100%;
  width: 70%;
  margin: 0 auto;
`
export const IntegrationLogo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2em;
  flex-direction: column;
  gap: 10px;
  label {
    font-size: small;
  }
`
export const ButtonWrapper = styled.div`
  margin: 2em 0;
`
